import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        
        this.isCustomLoad = this.el.hasAttribute('data-video-custom-load');
        this.isLoaded = false;
    }

    togglePlay(e) {
        if (e.way == 'enter') {
            if (this.isLoaded) {
                this.play();
            } else {
                if (this.isCustomLoad == false) {
                    this.loadAndPlay();
                }
            }
        } else {
            this.pause();
        }
    }

    play() {
        this.el.play();
        this.isLoaded = true;
    }

    pause() {
        this.el.pause();
    }

    loadAndPlay() {
        let source = this.el.querySelector('source[data-src]');
        if (source) {
            source.setAttribute('src', source.getAttribute('data-src'));
            source.removeAttribute('data-src');
            this.el.load();
            this.play();
            this.isLoaded = true;
        }
    }
}
